module.exports = __webpack_public_path__ + "img/addPhoto.svg";